<template>
  <div class="personal_center">
    <div class="personal_center_header">
      <img src="https://download.hecoos.com/enlightv/2025-17/9afd9fdb8b5717b4b118b43b3c449e13.png" alt=""
        @click="goIndex('/en')" />

      <div style="font-size:36px;color:white">
        User center
      </div>

      <div class="header_right">
        <button @click="goOrder">MyOrder</button>
        <button @click="logOut">Quit</button>
        <button @click="goIndex('/en')">Home</button>
      </div>
    </div>
    <div style="padding-bottom: 60px;">
      <div class="personal_content">
        <div class="personal_content_left">
          <h3>User information</h3>
          <div class="info-grid">
            <div class="info-column">
              <div class="info-row">
                <label>Account</label>
                <input type="text" :value="userInfo.hecoos_account || 'Not obtained'" disabled />
              </div>
              <div class="info-row">
                <label>Name</label>
                <input type="text" :value="userInfo.name || 'Not obtained'" disabled />
              </div>
              <div class="info-row">
                <label>Phone </label>
                <input type="text" :value="userInfo.phone || 'Not obtained'" disabled />
              </div>
              <div class="info-row">
                <label>Company</label>
                <input type="text" :value="userInfo.company || 'Not obtained'" disabled />
              </div>
              <div class="info-row">
                <label>Job</label>
                <input type="text" :value="userInfo.position || 'Not obtained'" disabled />
              </div>
            </div>
            <div class="info-column">
              <div class="info-row">
                <label>ID</label>
                <input type="text" :value="userInfo.rname || 'Not obtained'" disabled />
              </div>
              <div class="info-row">
                <label>E-mail</label>
                <input type="text" :value="userInfo.email || 'Not obtained'" disabled />
              </div>
              <div class="info-row">
                <label>City</label>
                <input type="text" :value="userInfo.city || 'Not obtained'" disabled />
              </div>
              <div class="info-row">
                <label>Seniority</label>
                <input type="text" :value="userInfo.work_duration || 'Not obtained'" disabled />
                <!-- <input type="text" :value="userInfo.work_duration + '年' || ''" disabled /> -->
              </div>
              <div class="info-row"  v-if="userInfo.phone || userInfo.email">
                <label>Password</label>
                <button class="forgetPsd" @click="pageTransition('/en/forget_password')">Reset password</button>
              </div>
            </div>
          </div>
          <div class="member-info">
            <span>Membership period:  <span v-text="start_time ? start_time +'~'+ stop_time : 'None'"></span></span>
            <button class="renew-btn" @click="pageTransition('/en/SoftwareSubscriptions')">Renew</button>
          </div>
        </div>
        <div class="divider"></div>
        <div class="personal_content_right">
          <h3>Member subscription</h3>
          <div class="subscription-options">
            <div class="subscription-item" @click="pageTransition('/en/SoftwareSubscriptions?orderType=3')">
              <p class="price">$12.00/week</p>

            </div>
            <div class="subscription-item" @click="pageTransition('/en/SoftwareSubscriptions?orderType=1')">
              <p class="price">$29.00/month</p>
              <p class="daily-price">0.97/day</p>
            </div>
            <div class="subscription-item" @click="pageTransition('/en/SoftwareSubscriptions?orderType=2')">
              <p class="price">$299.00/year</p>
              <p class="daily-price">$0.82/day</p>
            </div>
          </div>
        </div>
      </div>
      <button v-if="!userInfo.is_trial && (userInfo.phone || userInfo.email)" class="free-authorization-btn" @click="showModal = true">Get one month free license</button>
      <div v-else class="footer_text">
        <p>Invitation link: <span v-text="inviteLink + userInfo.recode"></span><button @click="copyInviteLink">Copy the link</button></p>
        <p class="w_80">Please share this link. After successfully inviting one friend to register as a member of hcoos, your member account will automatically receive 7-day free duration. If you invite multiple friends to register, the free duration can be accumulated. The maximum is 60 days (worth 396 yuan).</p>
        <table v-if="userInfo.invite_register.length > 0">
          <thead>
            <tr>
              <th>Serial Number</th>
              <th>Inviter</th>
              <th>Registration time</th>
              <th>Reward duration</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(userInfoItem, index) in userInfo.invite_register" :key="userInfoItem.id">
              <td>{{ index + 1 }}</td>
              <td>{{ userInfoItem.name }}</td>
              <td>{{ userInfoItem.register_time }}</td>
              <td>{{ userInfoItem.time }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Modal Dialog -->
      <div v-if="showModal" class="modal-overlay" @click.self="showModal = false">
        <div class="modal-content">
          <div class="modal-header">
            <h3>Improve personal information</h3>
            <button class="close-btn" @click="showModal = false">&times;</button>
          </div>
          <div class="modal-body">
            <p data-label="Nickname: "><input type="text" v-model="userInfo.rname"></p>
            <p data-label="Name："><input type="text" v-model="userInfo.name"></p>
            <p data-label="Email："><input type="text" v-model="userInfo.email"></p>
            <p data-label="Company Name:"><input type="text" v-model="userInfo.company"></p>
            <p data-label="city："><input type="text" v-model="userInfo.city"></p>
            <p data-label="Position:"><input type="text" v-model="userInfo.position"></p>
            <p data-label="Working experience:">
              <select v-model="userInfo.work_duration" name="" id="">
                <option value="1">one year</option>
                <option value="2">two years</option>
                <option value="3">three years</option>
                <option value="4">four years</option>
                <option value="5">five years</option>
                <option value="6">six years</option>
                <option value="7">seven years</option>
                <option value="8">eight years</option>
                <option value="9">nine years</option>
                <option value="10">ten years</option>
                <option value="11">Over 10 years old</option>
              </select>
            </p>
          </div>
          <div class="modal-footer">
            <button class="confirm-btn" @click="confirmAuthorization">确认授权</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import { Message } from "element-ui"
import { getFreeVip,getPaySuccess } from "@/api/api";
export default {
  data() {
    return {
      userInfo: {
        account: "",
        nickname: "",
        name: "",
        email: "",
        phone: "",
        city: "",
        company: "",
        workTime: "",
        position: "",
        memberExpire: "",
        recode: '',
        is_trial: ''
      },
      showModal: false,
      inviteLink: '',
      start_time:'',
      stop_time:'',
      // selectedOption: null
    };
  },
  created() {
    // 动态生成邀请链接
    this.inviteLink = `${window.location.origin}/#/en/register?recode=`;
    // console.log(window.location.origin);

    // console.log(this.inviteLink);
    if(store.state.adminUserInfo &&store.state.adminUserInfo.id){
      this.getPaySuccess()
    }
  },
  beforeMount() {
    this.userInfo = store.state.adminUserInfo;
    this.userInfo.is_trial = Number(this.userInfo.is_trial)
  },
  methods: {
    getPaySuccess(){
      getPaySuccess().then(res => {
        if(res.code == 200){
          if(res.data){
            let {start_time , stop_time} = res.data
            this.start_time = start_time
            this.stop_time = stop_time
          }

        }
      });
    },
    shuC(msg) {
      console.log(msg);

    },
    goOrder() {
      this.$router.push("/en/order");
    },
    goIndex(path) {
      this.$router.push(path);
    },
    logOut() {
      store.commit("clearAdminUserInfo");
      localStorage.clear();
      this.$router.push("/en/login");
    },
    pageTransition(url) {
      this.$router.push({
        path: url
      })
    },
    confirmAuthorization() {
      // console.log(this.userInfo);
      let postData = {
        name: this.userInfo.name,
        rname: this.userInfo.rname,
        email: this.userInfo.email,
        company: this.userInfo.company,
        city: this.userInfo.city,
        position: this.userInfo.position,
        work_duration: this.userInfo.work_duration,
      }
      // console.log(postData);

      getFreeVip(postData).then(res => {
        Message.success('获取成功，请重新登录。');
        setTimeout(() => {
          this.logOut()
        }, 1000)
      });

      this.showModal = false;
    },
    copyInviteLink() {
      navigator.clipboard.writeText(this.inviteLink + this.userInfo.recode)
        .then(() => {
          Message.success("The link has been copied to the clipboard");
        })
        .catch(err => {
          Message.error("Copy failed. Please do it manually...");
        });
    }
  },
};
</script>

<style lang="scss" scoped>
.personal_center {
  font-family: Arial, sans-serif;
  color: #333;
  position: relative;

  .personal_center_header {
    width: 100%;
    min-width: 1000px;
    height: 152px;
    background-color: #24272a;
    padding: 50px 120px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    img {
      width: 204px;
      height: 37px;
      cursor: pointer;
    }

    .header_right {
      display: flex;
      gap: 20px;

      button {
        font-size: 24px;
        height: 54px;
        border-radius: 27px;
        padding: 0 36px;
        cursor: pointer;
        border: none;
        // font-weight: bold;
      }

      & button:first-child {
        background-color: #070809;
        color: #fff;

        &:hover {
          background-color: #2a82e4;
        }
      }

      & button:nth-child(2) {
        background-color: #fff;
        color: #000;

        &:hover {
          background-color: #e4e6ef;
        }
      }
    }
  }

  .personal_content {
    width: 70%;
    margin: 20px auto;
    padding: 40px 0;
    display: flex;
    justify-content: space-between;
    gap: 40px;

    .personal_content_left {
      flex: 1;
      padding: 0 20px;

      h3 {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 30px;
        padding-bottom: 10px;
        text-align: center;
      }

      .info-grid {
        display: flex;
        gap: 40px;
      }

      .info-column {
        flex: 1;
      }

      .info-row {
        margin-bottom: 20px;

        .forgetPsd {
          border: 1px solid #2a82e4;
          background-color: #fff;
          color: #2a82e4;
          width: 100%;
          height: 40px;
          border-radius: 20px;
          // margin-top: 23px;
          cursor: pointer;

          &:hover {
            border: 1px solid #fff;
            background-color: #2a82e4;
            color: #fff;
          }
        }

        label {
          display: block;
          font-size: 14px;
          color: #777;
          margin-bottom: 5px;
        }

        input {
          width: 100%;
          height: 40px;
          border: 1px solid #e4e6ef;
          border-radius: 4px;
          padding: 0 10px;
          background-color: #f9f9f9;
          font-size: 14px;
        }
      }

      .member-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 30px;
        padding-top: 15px;
        border-top: 1px solid #eee;

        span {
          font-size: 14px;
          color: #333;
        }

        .renew-btn {
          border: none;
          background-color: #2a82e4;
          color: #fff;
          width: 18%;
          height: 40px;
          border-radius: 20px;
          margin-top: 10px;
          cursor: pointer;
          transform: translateY(-4px);

          &:hover {
            border: 1px solid #2a82e4;
            background-color: #fff;
            color: #2a82e4;
          }
        }
      }
    }

    .divider {
      width: 2px;
      background-color: #eee;
    }

    .personal_content_right {
      flex: 1;
      padding: 0 20px;

      h3 {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 54px;
        padding-bottom: 10px;
        text-align: center;
      }

      .subscription-options {
        display: flex;
        flex-direction: column;
        gap: 32px;
      }

      .subscription-item {
        border: 1px solid #e4e6ef;
        border-radius: 70px;
        padding: 30px 20px;
        cursor: pointer;
        transition: all 0.3s;
        text-align: center;

        &:hover {
          border-color: #2a82e4;
          background-color: #f5f9ff;
        }

        .price {
          font-size: 32px;
          font-weight: bold;
          margin-bottom: 5px;
        }

        .daily-price {
          font-size: 14px;
          color: #2a82e4;
        }
      }
    }
  }

  .free-authorization-btn {
    display: block;
    width: 300px;
    height: 50px;
    margin: 30px auto;
    background-color: #24272a;
    color: #fff;
    border: none;
    border-radius: 25px;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    transition: background-color 0.3s;

    &:hover {
      background-color: #2a82e4;
    }
  }

  .footer_text {
    text-align: center;
    font-size: 16px;

    .w_80{
      width: 80%;
      margin: 0 auto;
    }

    span {
      color: #2a82e4;
    }

    button {
      border: none;
      font-size: 10px;
      padding: 6px 12px;
      border-radius: 13px;
      margin-left: 6px;
      background-color: #cccccc;
      color: #fff;
      cursor: pointer;
    }

    table {
      width: 70%;
      border-collapse: collapse;
      margin-top: 20px;
      margin: 20px auto;
    }

    th,
    td {
      border: 1px solid #ddd;
      padding: 8px 12px;
      text-align: left;
    }

    th {
      background-color: #f2f2f2;
      font-weight: bold;
    }

    tr:nth-child(even) {
      background-color: #f9f9f9;
    }

    tr:hover {
      background-color: #f1f1f1;
    }

    .header {
      margin-bottom: 20px;
      font-size: 24px;
      font-weight: bold;
    }
  }

  /* Modal Styles */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .modal-content {
    background-color: white;
    border-radius: 10px;
    width: 600px;
    max-width: 90%;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    overflow: hidden;
  }

  .modal-header {
    padding: 20px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h3 {
      margin: 0;
      font-size: 18px;
      font-weight: bold;
    }

    .close-btn {
      background: none;
      border: none;
      font-size: 24px;
      cursor: pointer;
      color: #777;
      padding: 0;
      line-height: 1;
    }
  }

  .modal-body {
    padding: 20px 54px;

    p {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      font-size: 14px;

      &::before {
        content: attr(data-label);
        display: inline-block;
        width: 80px;
        text-align: justify;
        text-align-last: justify;
        padding-right: 10px;
      }

      input,
      select {
        // 同时为input和select设置相同样式
        flex: 1;
        height: 40px;
        border: 1px solid #e4e6ef;
        border-radius: 4px;
        padding: 0 10px;
        background-color: #f9f9f9;
        font-size: 14px;
        appearance: none; // 移除默认样式
        background-repeat: no-repeat;
        background-position: right 10px center;
        background-size: 12px;
      }

      select {
        cursor: pointer;
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23777'%3e%3cpath d='M7 10l5 5 5-5z'/%3e%3c/svg%3e");


        option {
          padding: 8px;
        }
      }
    }
  }

  .modal-footer {
    padding: 20px;
    border-top: 1px solid #eee;
    text-align: center;

    .confirm-btn {
      background-color: #2a82e4;
      color: white;
      border: none;
      border-radius: 20px;
      padding: 10px 30px;
      font-size: 16px;
      cursor: pointer;
      transition: background-color 0.3s;

      &:hover {
        background-color: #1a6bc8;
      }
    }
  }
}
</style>
